export default "__VITE_ASSET__BDYQLwby__"